<template>
  <wrapper @clear="clear()" :showClear="showClear" :filter="filter">
    <div class="filters__options filters__options--checkbox">
      <template v-for="term in terms">
        <checkbox
          @change="toggleTerm(term)"
          :term="term"
        />
      </template>
      <div class="filters__more" v-if="more && !showAll" @click="showMore()">
        Pokaż więcej (+{{ moreCount }})
      </div>
      <div class="filters__more" v-if="more && showAll" @click="hideMore()">
        Pokaż mniej
      </div>
    </div>
  </wrapper>
</template>

<script>
import wrapper from "./Wrapper.vue";
import checkbox from "./Checkbox.vue";

export default {
  name: "checkboxes",
  components: {
    wrapper: wrapper,
    checkbox: checkbox
  },
  props: {
    filters: Array,
    filter: Object
  },
  data() {
    return {
      showAll: false
    };
  },
  mounted() {
  },
  computed: {
    moreCount() {
      return Object.values(this.filter.terms).length - 5;
    },
    terms() {
      let terms = Object.values(this.filter.terms).reduce((acc, term) => {
        acc.set(term.term_id, term);

        term.active = this.filter.filter.values.includes(term.slug)

        const parent = term.parent === 0
          ? acc.get("root")
          : (acc.get(term.parent).children ??= []);

        parent.push(term);

        return acc;
      }, new Map([
        ["root", []]
      ])).get("root");

      console.log(terms);

      if (this.showAll) {
        return terms;
      }

      if (this.filter.filter.more_less === "yes") {
        return terms.slice(0, 5);
      } else {
        return terms;
      }
    },
    more() {
      return Object.values(this.filter.terms).length > 5
        && this.filter.filter.more_less === "yes";
    },
    showClear() {
      return Object.values(this.filter.filter.values).length > 0;
    }
  },
  emits: ["change"],
  watch: {},
  methods: {
    clear() {
      this.filter.filter.values = [];
      this.$emit("change");
    },
    hideMore() {
      this.showAll = false;
    },
    showMore() {
      this.showAll = true;
    },
    async toggleTerm(term) {
      const filter = this.filter.filter;
      if (filter.values.includes(term.slug)) {
        filter.values = filter.values.filter(a => a !== term.slug);
      } else {
        filter.values.push(term.slug);
      }

      this.$emit("change");
    }
  }
};
</script>
